module.exports = __webpack_public_path__ + "static/img/hero-elon-doge.112b505b.png";